'use client';
import { useMemo } from 'react';
import { cn } from '../lib/utils';

type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> & { level: number };

export function Heading({ level, children, className, ...props }: HeadingProps) {
    const id = useMemo(() => {
        const text = typeof children === 'string' ? children : String(children);
        return text
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
    }, [children]);

    type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    const Component = `h${level}` as HeadingTag;
    const baseClasses = 'scroll-mt-24 font-semibold';

    return (
        <Component id={id} className={cn(baseClasses, className)} {...props}>
            {children}
        </Component>
    );
}

